import { ACTIONS } from '../const';
import { switcher } from './utils';

const defaultCustomer = {
    help_url: null,
};

export default switcher(defaultCustomer, {
    [ACTIONS.SYNC_CUSTOMER](state, action) {
        const { help_url } = action.data;
        return {
            ...state,
            help_url,
        };
    },
});



// WEBPACK FOOTER //
// ./src/reducers/customer.js